import {$qs} from '../../../@shared/ts/dom';

function handleDisputeSettingsUi() {
	const statusSettingRow = $qs<HTMLTableRowElement>('select[name="peachpay_stripe_advanced_admin_settings_dispute_order_status"]')?.parentElement?.parentElement?.parentElement;
	const disputeCreateSetting = $qs<HTMLInputElement>('input[name="peachpay_stripe_advanced_admin_settings_dispute_created"]');

	if (!disputeCreateSetting || !statusSettingRow) {
		return;
	}

	const hideSettingRow = () => {
		statusSettingRow.classList.add('hide');
	};

	const showSettingRow = () => {
		statusSettingRow.classList.remove('hide');
	};

	if (disputeCreateSetting.checked) {
		showSettingRow();
	} else {
		hideSettingRow();
	}

	disputeCreateSetting.addEventListener('change', () => {
		if (disputeCreateSetting.checked) {
			showSettingRow();
		} else {
			hideSettingRow();
		}
	});
}

export {handleDisputeSettingsUi};
